import {log} from "@dp-instant/utils";
import {useState} from "preact/hooks";

export const ShareTournamentFormDebug = () => {
    const [state, setState] = useState<{data?: string; score: number}>({
        data: undefined,
        score: 0
    });
    return (
        <form>
            <div>
                <label for="iscore">Score:</label>
                <input
                    type="text"
                    id="iscore"
                    name="iscore"
                    value={state.score}
                    onChange={(e: any) =>
                        setState({...state, score: parseInt(e!.currentTarget!.value || 0)})
                    }
                />
            </div>
            <div>
                <label for="ttitle">Data (JSON):</label>
                <input
                    type="text"
                    id="ttitle"
                    name="ttitle"
                    onChange={(e: any) => setState({...state, data: e!.currentTarget!.value || 0})}
                />
            </div>
            <a
                href="#"
                onClick={() =>
                    window.FBInstant.tournament
                        .shareAsync(state)
                        .then((data: any) => {
                            debugger;
                        })
                        .catch(log.error)
                }
            >
                {"Update"}
            </a>
        </form>
    );
};
